<template>
  <div id='index' v-if="body_show">
    <!-- 邀请返现 -->
    <div class="share" v-if="(data.shareinfo || is_red) && shareshow">
      <img src="@a/sha2.png" class="close" alt="" @click="shareshow=false" />
      <div class="clearfix"></div>
      <div v-if="data.shareinfo">
        <h2><span class="text-ellipsis">{{data.sharenickname}}</span>发起的邀请</h2>
        <div class="share_per clearfix">
          <div class="sp_l">
            <img :src="data.shareheadimgurl" alt="" />
            <p class="text-ellipsis">{{data.sharenickname}}</p>
          </div>
          <img src="@a/sha1.png" alt="" class="lj_img" />
          <div class="sp_l">
            <img :src="headImg" alt="" />
            <p class="text-ellipsis">{{data.userdetail.nickname}}</p>
          </div>
        </div>
        <div class="sp_b clearfix">
          <span><span>￥</span>{{data.shareprice}}</span>
          <div class="sp_br">
            <h3>好友邀请为你节省{{data.shareprice}}元</h3>
            <h4 v-if="data.shareend">有效日期：{{data.shareend}}</h4>
            <h4 v-else>{{data.sharestart}}</h4>
          </div>
        </div>
      </div>
      <div class="sp_b clearfix" v-if="is_red && data.otheractivity">
        <span><span>￥</span>{{data.redPrice.use_money}}</span>
        <div class="sp_br">
          <h3 class="text-ellipsis">{{data.redPrice.describe}}</h3>
          <h4>有效日期：{{data.redPrice.start_time}}-{{data.redPrice.end_time}}</h4>
        </div>
      </div>
    </div>
    <!-- 公用头部 -->
    <!-- capacity 是否是扩容 -->
    <public-header :colors="'#fff'" :capacity="capacity" :routArg="routArg" :headimg="headImg"></public-header>
    <!-- 自我探索详情页 -->
    <div class="discovery-box">
      <img width="100%" src="@a/self_discovery/zuijia_01.png">
      <router-link to="/index">
        <img class="logo" src="@a/self_discovery/discovery_logo.png">
      </router-link>
      <!-- 价格和时间 -->
      <div class="money_box" v-if="!data.ishavedbuy">
        <div class="money_">
          <div class="money_left" v-if="surplusPriceTime>0">优惠价：<span>¥{{courseprice}}</span></div>
          <div class="money_left" v-else>价格：<span>¥{{originalprice}}</span></div>
          <div class="money_time" v-if="surplusPriceTime>0">倒计时 <span>{{day}}</span> 天 <a>{{time}}</a>
            <br/>恢复原价 <span>{{originalprice}}</span> 元</div>
          <!-- <div class="money_time money_time1" v-else><span>5000+ </span>学员好评推荐</div> -->
          <div class="money_right" v-else>
            把自己发挥到极致！
          </div>
        </div>
        <div class="mev clearfix">
          <van-radio-group :class="['radio_group',!item.sign?'radio_group_over':'']" v-for="(item,index) in data.list" :key="index" v-model="radio" :disabled="!item.sign?true:false">
            <van-radio :name="item.id">
              {{item.course_begintime_str}}入营
            </van-radio>
          </van-radio-group>
        </div>
      </div>
      <div class="money_box" v-else>
        <!-- <div class="money_">
            <div class="money_left">优惠价：<span>¥{{data.courseprice}}</span></div>
            <div class="money_right">原价{{data.originalprice}}，限时优惠{{(data.originalprice*100-data.courseprice*100)/100}}</div>
        </div> -->
        <div class="money_">
          <div class="money_left" v-if="surplusPriceTime>0">优惠价：<span>¥{{courseprice}}</span></div>
          <div class="money_left" v-else>价格：<span>¥{{originalprice}}</span></div>
          <div class="money_time" v-if="surplusPriceTime>0">倒计时 <span>{{day}}</span> 天 <a>{{time}}</a>
            <br/>恢复原价 <span>{{originalprice}}</span> 元</div>
          <div class="money_right" v-else>
            把自己发挥到极致！
          </div>
        </div>
        <div class="date_ date_now" v-for="(item,index) in data.list" :key="index">{{item.course_begintime_str}}开营&nbsp;&nbsp;已购</div>
        <div :class="['date_',!item.sign?'date_over':'']" v-for="(item,index) in data.buyList" :key="index">{{item.course_begintime_str}}入营</div>
        <div class="clearfix"></div>
      </div>
      <public-spell :scrabble="scrabble" :ishavedbuy="data.ishavedbuy" v-if="scrabble"></public-spell>
      <!-- 自我探索图片 -->
      <img width="100%" src="@a/self_discovery/zuijia_03.png">
      <img width="100%" src="@a/self_discovery/zuijia_04.png">
      <img width="100%" src="@a/self_discovery/zuijia_05.png">
      <img width="100%" src="@a/self_discovery/zuijia_06.png">
      <img width="100%" src="@a/self_discovery/zuijia_07.png">
      <img width="100%" src="@a/self_discovery/zuijia_08.png">
      <img width="100%" src="@a/self_discovery/zuijia_09.png">
      <img width="100%" src="@a/self_discovery/zuijia_10.png">
      <img width="100%" src="@a/self_discovery/zuijia_11.png">
      <img width="100%" src="@a/self_discovery/zuijia_12.png">
      <img width="100%" src="@a/self_discovery/zuijia_13.png">
      <img width="100%" src="@a/self_discovery/zuijia_14.png">
      <img width="100%" src="@a/self_discovery/zuijia_15.png">
      <img width="100%" src="@a/self_discovery/zuijia_16.png">
      <img width="100%" src="@a/self_discovery/zuijia_17.png">
      <img width="100%" src="@a/self_discovery/zuijia_18.png">
      <img width="100%" src="@a/self_discovery/zuijia_19.png">
      <img width="100%" src="@a/self_discovery/zuijia_20.png">
      <img width="100%" src="@a/self_discovery/zuijia_21.png">
      <img width="100%" src="@a/self_discovery/zuijia_22.png">
      <img width="100%" src="@a/self_discovery/zuijia_23.png">
      <img width="100%" src="@a/self_discovery/zuijia_24.png">
      <img width="100%" src="@a/self_discovery/zuijia_25.png">
      <img width="100%" src="@a/self_discovery/zuijia_26.png">
      <img width="100%" src="@a/self_discovery/zuijia_27.png">
      <img width="100%" src="@a/self_discovery/zuijia_28.png">
      <img width="100%" src="@a/self_discovery/zuijia_29.png">
      <img width="100%" src="@a/self_discovery/zuijia_30.png">
      <img width="100%" src="@a/self_discovery/zuijia_31.png">
      <img width="100%" src="@a/self_discovery/zuijia_32.png">
      <img width="100%" src="@a/self_discovery/zuijia_33.png">
      <img width="100%" src="@a/self_discovery/zuijia_34.png">
      <img width="100%" src="@a/self_discovery/zuijia_35.png">
      <img width="100%" src="@a/self_discovery/zuijia_36.png">
      <img width="100%" src="@a/self_discovery/zuijia_37.png">
      <img width="100%" src="@a/self_discovery/zuijia_38.png">
      <img width="100%" src="@a/self_discovery/zuijia_39.png">
      <img width="100%" src="@a/self_discovery/zuijia_40.png">
      <img width="100%" src="@a/self_discovery/zuijia_41.png">
      <img width="100%" src="@a/self_discovery/zuijia_42.png">
      <img width="100%" src="@a/self_discovery/zuijia_43.png">
      <img width="100%" src="@a/self_discovery/zuijia_44.png">
      <img width="100%" src="@a/self_discovery/zuijia_45.png">
      <img width="100%" src="@a/self_discovery/zuijia_46.png">
      <img width="100%" src="@a/self_discovery/zuijia_47.png">
      <img width="100%" src="@a/self_discovery/zuijia_48.png">
      <img width="100%" src="@a/self_discovery/zuijia_49.png">
      <img width="100%" src="@a/self_discovery/zuijia_50.png">
      <img width="100%" src="@a/self_discovery/zuijia_51.png">
      <img width="100%" src="@a/self_discovery/zuijia_52.png">
    </div>
    <!-- 自我探索详情页  end -->
    <!-- <div class="banq">
      * 本课程由新精英生涯（北京）教育科技有限公司版权所有，违者必究
    </div> -->
    <!-- 按钮 -->
    <!-- <div class="into_btn_box">
      <div class="into_btn" v-if="!data.ishavedbuy">
        <a class="free_learn" @click="free_learn" href="javascript:;">免费试学</a>
        <a class="sign_immediately only" @click="signHandle" v-if="surplus>0">
            立即报名&nbsp;&nbsp;<span>仅剩席位:{{surplus}}</span><b>报名截止时间: {{begintime}}</b>
        </a>
        <a class="sign_immediately sign_immediatelys" v-else>本期已满</a>
      </div>
      <router-link class="into_project" :to="url_substying(data.ishavedbuy) + '?cid=' + cid" v-else>进入【项目】</router-link>
    </div> -->
    <div class="into_btn_box">
      <div class="into_btn" v-if="!data.ishavedbuy">
        <div class="into_btn_spe" v-if="scrabble">
          <a class="free_learn spell" href="javascript:;" @click="signHandle">早鸟价￥{{originalprice}}<br/><span>仅剩席位:{{surplus}}</span></a>
          <router-link class="sign_immediately" :to="'/course_spell?scrabble_type=create&bid=' + data.bid" v-if="surplus>0">
            发起拼团 ￥{{scrabble.price}}</b>
          </router-link>
          <a class="sign_immediately sign_immediatelys" v-else>
            本期已满</b>
          </a>
        </div>
        <div class="into_btn_spe" v-else>
          <a class="free_learn" @click="free_learn" href="javascript:;">免费试学</a>
          <a class="sign_immediately only" @click="signHandle" v-if="surplus>0">
            立即报名&nbsp;&nbsp;<span>仅剩席位:{{surplus}}</span><b>报名截止时间: {{begintime}}</b>
        </a>
          <a class="sign_immediately sign_immediatelys" v-else>本期已满</a>
        </div>
      </div>
      <a v-else>
        <router-link class="into_project" v-if="scrabble && scrabble.is_leader" :to="'/course_spell?scrabble_type=invite&scrabble_id=' + scrabble.scrabble_id">邀请好友拼团</router-link>
        <router-link class="into_project" v-else :to="url_substying(data.ishavedbuy) + '?cid=' + cid">进入【项目】</router-link>
      </a>
    </div>
    <van-popup v-model="share_show" position="bottom">
      <div class="share_order">
        <img src="@a/sha2.png" class="close" alt="" @click="share_show=false" />
        <div class="clearfix"></div>
        <h2>订单详情</h2>
        <h3 class="clearfix">课程价格<span>￥{{courseprice}}</span></h3>
        <van-radio-group class="order_group" v-for="(item,index) in order_group" :key="index" v-model="use_id">
          <van-radio :name="item.id">
            {{item.name}}<span>- ￥{{item.price}}</span>
          </van-radio>
        </van-radio-group>
        <a class="into_project" @click="signHandle" v-if="typeof use_id === 'string' || typeof use_id === 'number'">立即付款 ￥{{order_price}}</a>
        <a class="into_project into_project_over" v-else>立即付款</a>
      </div>
    </van-popup>
    <!-- 引入卡片弹窗 -->
    <public-pop v-if="$route.query.bid" :imgUrl="data.sharebuy_placard" :cid="cid" :text_assistant="'长按添加助理<br/>领取更多'" :insert_text="'课程资料'" :text_card="'长按保存分享，每入学1位您可获得80元奖学金'" :type="1"></public-pop>
    <!-- 验证手机号和付款 -->
    <public-mobile ref="handle" :cid="cid" :use_id="use_id" :source="source" :sharetype="sharetype" :type="'course'" :pdk="pdk" :aspx="aspx" @statistic_="statistic_"></public-mobile>
    <public-ewm :assistant_show="assistant_show" :ewm_img="ewm_img"></public-ewm>
    <!-- 红包 -->
    <van-popup class="prize-pop" v-model="showPrize" :close-on-click-overlay="false">
      <div :class="[prizeBg ? 'show' : '', 'prize pr']">
        <div @click="pull_click" class="close-btn"></div>
        <div class="bg pr">
          <div v-if="!prizeBg" class="pr">
            <img @click="prizeBg_click" class="prize-btn" src="@a/Prize_btn.png" alt="" />
            <!-- <img style="opacity: 1;" src="@a/Prize_bg (2).png" alt="" /> -->
            <p class="text-tip row-public">{{data.redPrice.name}}</p>
            <img class="logo_top reward_logo" src="@a/course_reward_logo.png" />
            <p class="tip-footer row-public row-spe">- 好好学习，天天向上 -</p>
          </div>
          <div v-else>
            <p class="h1-head row-public">恭喜您获得</p>
            <p class="row-public greet">{{describe}}</p>
            <div class="num pa" style="width: 100%;">
              <p class="h2-row row-public"><span class="num-type">￥</span>{{money}}</p>
              <p class="size-sm row-public">可用于抵扣课程学费</p>
            </div>
            <img class="logo_bottom reward_logo" src="@a/course_reward_logo.png" alt="" />
            <p class="tip-footer row-public">- 好好学习，天天向上 -</p>
          </div>
          <img style="opacity: 1;" src="@a/Prize_bg (1).png" alt="" />
          <!-- bg -->
        </div>
      </div>
    </van-popup>
    <van-popup v-model="big_show" class="pop_assistant">
      <div class="pop_assistant_box">
        <img :src="bigqrcode" />
        <h3><span>扫码进群</span><br/><span>领取 </span> <span class="on">免费试学</span> <span> 名额</span><br/><span>还有限时福利！</span></h3>
      </div>
    </van-popup>
    <!-- 未关注弹窗 -->
    <van-popup :close-on-click-overlay="false" v-model="not_concern" class="pop_assistant">
      <div class="pop_assistant_box">
        <h3 style="font-weight: bold">{{data.userdetail.nickname}}你好！您已成功报名{{data.coursename}}，为了不和组织失联，请关注下方二维码。</h3>
        <h4>识别或扫描二维码</h4>
        <img src="@a/carrer.png" />
        <h4>已关注的看官自动忽略</h4>
      </div>
    </van-popup>
    <!-- 过年春节弹窗-->
    <!-- <van-popup  v-model="spring_festival" class="Spring-Festival">
      <div class="box">
        <img src="@a/zwts.png" alt="">
      </div>
    </van-popup> -->
  </div>
</template>
<script>
import { isMain } from '@/utils/tools'
import { statistics} from "@/api/public";
import { coursedetail, grabRed, getproject} from "@/api/course"
import { project_click_time} from "@/api/course"
import { statistic_next} from "@/api/course"
import { shareCon} from "@/utils/wxconfig";
import { getStorage, setStorage} from "@/utils/tools"
import { newCourse } from '@/utils/course'
let xx = require("../../../assets/carrer.png");
export default {
  data() {
      return {
        showPrize: false,
        prizeBg: false,
        money: "",
        describe: "",
        pblname: "pl",
        name: "",
        music: "",
        body_show: false,
        cid: null,
        headImg: "",
        data: {},
        phone: null,
        source: '',
        pdk: '',
        aspx: '',
        assistant_show: false,
        ewm_img: "",
        routArg: {},
        courseprice: null,
        originalprice: null,
        surplus: null,
        radio: '',
        shareshow: true,
        share_show: false,
        is_red: false,
        order_group: [],
        use_id: null,
        order_price: '',
        big_show: false,
        bigqrcode: '',
        free_show: false,
        sharetype: "",
        timestamp: '',
        time: '',
        day: 0,
        not_concern: false,
        begintime: '',
        is_showtext: false,
        // 自我探索
        imageList: [],
        scrabble: false,
        capacity:'',
        spring_festival:true
      }
    },
    watch: {
      radio(curVal, oldVal) {
        // 修改课程期数
        for (let arg of this.data.list) {
          if (arg.id == curVal) {
            let timestampcha = Date.parse(new Date()) / 1000 - this.timestamp;
            this.surplusPriceTime = arg.surplusPriceTime - timestampcha;
            this.courseprice = arg.courseprice;
            this.originalprice = arg.originalprice;
            this.surplus = arg.surplus;
            this.begintime = arg.begintime;
            if (this.use_id != '') {
              this.order_price = (this.courseprice * 100 - this.data.redPrice.use_money * 100) / 100;
            } else {
              this.order_price = (this.courseprice * 100 - this.data.shareprice * 100) / 100;
            }
          }
        };
        clearInterval(this.sin);
        this.timeTostring();
        this.cid = String(curVal);
      },
      use_id(curVal, oldVal) {
        if (curVal != '') {
          this.order_price = (this.courseprice * 100 - this.data.redPrice.use_money * 100) / 100;
        } else {
          this.order_price = (this.courseprice * 100 - this.data.shareprice * 100) / 100;
        }
      }
    },
    methods: {
      set_session(key, value) {
        let session = window.sessionStorage;
        if (!session) {
          // 会话缓存
          if (!Vue.prototype._session) {
            Vue.prototype._session = {};
          }
          session = Vue.prototype._session;
        }
        session[key] = value;
      },
      get_session(key) {
        let session = window.sessionStorage;
        if (!session) {
          // 会话缓存
          if (!Vue.prototype._session) {
            Vue.prototype._session = {};
          }
          session = Vue.prototype._session;
        }
        let ret = session[key];
        switch (ret) {
          case "true":
            ret = true;
            break;
          case "false":
            ret = false;
            break;
        }
        return ret;
      },
      pull_click() {
        this.showPrize = false
        if (this.prizeBg) {
          this.pullData();
        }
      },
      prizeBg_click() {
        grabRed({
            red_id: this.data.redPrice.red_id
          })
          .then((data) => {
            if (data.code == 10002) {
              this.$toast(data.data.msg);
            } else {
              this.prizeBg = true;
              this.money = data.money;
              this.describe = data.describe;
            }
          })
      },
      // 当前时间的格式化字符串
      timeTostring() {
        if (this.surplusPriceTime > 0) {
          this.sin = setInterval(() => {
            var secondTime = parseInt(this.surplusPriceTime); // 秒
            var minuteTime = 0; // 分
            var hourTime = 0; // 小时
            var dayTime = 0; // 天
            if (secondTime > 60) { //如果秒数大于60，将秒数转换成整数
              //获取分钟，除以60取整数，得到整数分钟
              minuteTime = parseInt(secondTime / 60);
              //获取秒数，秒数取佘，得到整数秒数
              secondTime = parseInt(secondTime % 60);
              //如果分钟大于60，将分钟转换成小时
              if (minuteTime > 60) {
                //获取小时，获取分钟除以60，得到整数小时
                hourTime = parseInt(minuteTime / 60);
                //获取小时后取佘的分，获取分钟除以60取佘的分
                minuteTime = parseInt(minuteTime % 60);
                if (hourTime > 24) {
                  //获取天，获取小时除以24，得到整数天
                  dayTime = parseInt(hourTime / 24);
                  //获取天后取佘的小时，获取小时除以24取佘的小时
                  hourTime = parseInt(hourTime % 24);
                }
              }
            }
            var result = ((secondTime < 10) ? "0" : "") + parseInt(secondTime);

            if (minuteTime > 0) {
              result = ((minuteTime < 10) ? "0" : "") + parseInt(minuteTime) + ":" + result;
            }
            if (hourTime > 0) {
              result = ((hourTime < 10) ? "0" : "") + parseInt(hourTime) + ":" + result;
            }
            if (dayTime > 0) {
              this.day = dayTime;
            } else {
              this.day = 0;
            }

            this.time = result;
            this.surplusPriceTime -= 1;
          }, 1000);
        } else {
          clearInterval(this.sin)
        }

      },
      pullData() {
        this.$toast.loading({
          duration: 0,
          mask: true,
          message: "加载中..."
        });
        // 请求详情页数据
        coursedetail({
            bid: this.$route.query.bid
          })
          .then((data) => {
            this.ewm_img = xx;
            this.data = data;
            this.sharetype = data.sharetype;
            this.bigqrcode = data.bigqrcode;
            this.scrabble = data.scrabble;
            document.title = data.bigcoursename;
            this.body_show = true;
            var date = new Date();
            var day = date.getDate();
            if (day >= 24) {
              this.is_showtext = true
            }
            // 判断是否关注
            // if(!data.subscribe && data.buyList.length>0) {
            //   this.not_concern = true;
            // }
            //
            if(newCourse(data.id)) {
              this.capacity = 'capacity';
            }
            if (data.red_envelope) {
              this.set_session('bigqrcodeshow', data.red_envelope.qrcode_state == 0);
            }
            if (this.get_session('bigqrcodeshow') !== undefined) {
              data.bigqrcodeshow = this.get_session('bigqrcodeshow');
            }
            this.free_show = !data.bigqrcodeshow;
            this.is_red = !data.redType && data.redPrice != '' && data.redshow;
            if (!data.subscribe && data.qrcode.length > 0) {
              this.assistant_show = true;
              this.ewm_img = data.qrcode;
            }
            this.source = this.$route.query.source || '';
            this.timestamp = Date.parse(new Date()) / 1000;
            // 课程期数
            if (!data.list || data.list.length == 0) {
              this.cid = data.id;
              this.surplusPriceTime = 0;
              this.courseprice = 0;
              this.originalprice = 0;
              this.surplus = 0;
            } else {
              for (let arg of data.list) {
                if (arg.selected) {
                  this.surplusPriceTime = arg.surplusPriceTime;
                  this.courseprice = arg.courseprice;
                  this.originalprice = arg.originalprice;
                  this.surplus = arg.surplus;
                  this.begintime = arg.begintime;
                  this.radio = arg.id;
                  this.cid = String(arg.id);
                }
              };
            }
            this.timeTostring();
            this.showPrize = data.redType;
            if (this.data.shareinfo) {
              this.order_price = (this.originalprice * 100 - this.data.shareprice * 100) / 100;
            } else {
              if (this.is_red) {
                this.order_price = (this.originalprice * 100 - this.data.redPrice.use_money * 100) / 100;
              }
            }

            if (this.data.shareinfo) {
              this.order_group.push({
                name: "好友邀请",
                price: this.data.shareprice,
                id: ''
              })
            }
            if (this.is_red && this.data.otheractivity) {
              this.order_group.push({
                name: "红包折扣",
                price: this.data.redPrice.use_money,
                id: this.data.redPrice.use_id
              })
            }
            // 分享
            this.pdk = this.$route.query.pdk || '';
            this.aspx = this.$route.query.aspx || '';
            if (this.source) {
              this.routArg['source'] = this.source;
            }
            if (this.pdk) {
              this.routArg['pdk'] = this.pdk;
            }
            if (this.aspx) {
              this.routArg['aspx'] = this.aspx;
            }
            // 用户图像
            this.headImg = data.userdetail.headimgurl;
            this.cacheUserConfig = {
              pdk: data.pdk,
              aspx: data.aspx
            };
            // 关闭Loading
            this.$toast.clear();
            shareCon("course2", this);
            // 神策统计
            sensors.track('courseDetails', {
              classification: data.bigcoursename,
              classification_id: this.$route.query.bid,
              channel_name: this.source || '',
              course_id: this.cid,
              course_name: data.coursename,
              share_user_id: this.pdk || '',
              course_discount_price: data.courseprice,
              course_original_price: data.originalprice,
              course_starttime: data.begintime,
              // 新增
              course_user_type: data.ishavedbuy ? "已付费" : "未付费"
            })
          })

      },
      // 立即报名
      signHandle() {
        this.statistical("coursebtn");
        // 神策统计--点击立即报名按钮
        sensors.track('applyCourse', {
          apply_page_url: location.href,
          apply_page_title: this.data.bigcoursename,
          classification: this.data.bigcoursename,
          classification_id: this.$route.query.bid,
          course_id: this.cid,
          course_name: this.data.coursename,
          course_discount_price: this.data.courseprice,
          course_original_price: this.data.originalprice,
          course_starttime: this.data.begintime
        });
        // 把神策数据存到本地缓存
        let godPolicy = {
          course_id: this.cid,
          classification: this.data.bigcoursename,
          course_name: this.data.coursename,
          course_discount_price: this.data.courseprice,
          course_original_price: this.data.originalprice,
          course_starttime: this.data.begintime
        };
        setStorage('godPolicy', 'godPolicy', godPolicy);
        if (this.data.refunding) {
          this.$toast("有退款订单，不能购买！");
        } else {
          if ((this.data.shareinfo || this.is_red) && !this.share_show) {
            this.share_show = true;
          } else {
            if (this.data.mobilestatus) {
              // 是否需要验证验证码
              this.$refs.handle.need_verify = this.data.need_verify || false;
              // 判断用户手机号是否已验证
              this.$refs.handle.phone = this.data.userdetail.mobile ? this.data.userdetail.mobile : null;
              this.$refs.handle.show = true;
            } else {
              this.$refs.handle.pay()
            }
          }

        }

      },
      // 本地统计
      statistical(data) {
        statistics({
          type: data
        }).then();
      },
      statistic_() {
        statistic_next({
            cid: this.data.id
          })
          .then();
      },
      // 免费试学
      free_learn() {
        this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        getproject({
            cid: this.cid
          })
          .then((data) => {
            this.toProjectHandle(data.projects[0].cpid);
            this.$toast.clear();
          }).catch((err) => {
            this.toProjectHandle();
            this.$toast.clear();
          });

      },
      // 跳转项目详情页
      toProjectHandle(cpid) {
        project_click_time({
          cid: this.cid
        }).then((data) => {
          // 免费试学跳转
          if (!this.data.bigqrcodeshow) {
            this.$router.push({
              path: '/project_details',
              query: {
                'cid': this.cid,
                'cpid': cpid,
                'pdk': this.routArg.pdk,
                'aspx': this.routArg.aspx,
                'source': this.routArg.source
              }
            });
          } else {
            this.big_show = true;
          }
        });
      },
      // 截取返回link中的地址中的路由名称
      url_substying(url_) {
        let index = url_.lastIndexOf('/');
        let last = url_.lastIndexOf('.');
        let x = url_.substring(index, last);
        return x
      }
    },
    created() {
      this.pullData();
    },
    destroyed() {
      clearInterval(this.sin)
    }
}
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.Spring-Festival img{
  width:600px;
}
#index {
  background: url(../../../assets/self_discovery/zuijia_02.png) no-repeat;
  z-index: 1;
  position: relative;
  padding-bottom: 98px;
  background-size: 100% 100%;
}

// 自我探索
.discovery-box {
  position: relative;
  img.logo {
    position: absolute;
    left: 44px;
    top: 22px;
    width: 128px;
    height: 48px;
  }
}

.share {
  background-color: #EA345C;
  padding: 30px;
  h2 {
    font-size: 34px;
    color: #fff;
    text-align: center;
    span {
      max-width: 165px;
      display: inline-block;
      vertical-align: sub;
    }
  }
  img.close {
    width: 28px;
    float: right;
  }
  .share_per {
    width: 510px;
    margin: 0 auto;
    margin-top: 30px;
    .sp_l {
      width: 126px;
      float: left;
      text-align: center;
      img {
        width: 90px;
        border-radius: 50%
      }
      p {
        margin-top: 20px;
        color: #fff;
        font-size: 26px;
        width: 126px;
      }
    }
    img.lj_img {
      margin-top: 10px;
      width: 258px;
      float: left;
    }
  }
  .sp_b {
    width: 690px;
    height: 125px;
    background-image: url(../../../assets/sha3.png);
    background-size: cover;
    margin-top: 30px;
    position: relative;
    span {
      color: #EA345C;
      font-size: 38px;
      min-width: 140px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 30px;
      span {
        font-size: 28px;
        position: static;
      }
    }
    .sp_br {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 30px;
      h3 {
        color: #EA345C;
        font-size: 28px;
        width: 420px;
        line-height: 40px;
      }
      h4 {
        color: #999999;
        font-size: 20px;
        line-height: 30px;
      }
    }
  }
}

.share_order {
  width: 100%;
  img {
    float: right;
    width: 28px;
    margin: 30px;
  }
  h2 {
    margin-top: 20px;
    color: #333;
    font-size: 34px;
    text-align: center;
    font-weight: bold;
  }
  h3 {
    color: #333;
    font-size: 26px;
    margin: 0 30px;
    margin-top: 40px;
    padding-bottom: 10px;
    border-bottom: 2px solid #ccc;
    margin-bottom: 40px;
    span {
      float: right;
    }
    .spec {
      color: #EA345C;
    }
  }
  h3.child {
    border-bottom: none;
    margin-top: 20px;
  }
  a.into_project {
    display: block;
    width: 100%;
    line-height: changeRem(1.96)+px;
    text-align: center;
    background: rgba(235, 80, 50, 1);
    text-align: center;
    color: #fff;
    margin-top: 40px;
    font-size: 34px;
  }
  a.into_project_over {
    background-color: #ccc
  }
}

// 课程的价格和开课时间
.money_box {
  border-radius: changeRem(.32)+px;
  margin: 0 16px 20px;
  box-shadow: 0px 0px 14px 0px rgba(235, 80, 50, 0.1);
  background-color: #FFF;
  position: relative;
  padding: 0 changeRem(.6)+px changeRem(.8)+px;
  z-index: 1;
  .money_ {
    display: flex;
    padding-top: 35px;
    .money_left {
      margin-right: auto;
      font-size: changeRem(.52)+px;
      span {
        font-size: 44px;
        color: #EA345C;
      }
    }
    .money_right {
      margin-left: auto;
      font-size: changeRem(.48)+px;
      background-color: #EA345C;
      color: #FFF;
      position: relative;
      // height: changeRem(.6)+px;
      line-height: changeRem(.6)+px;
      align-self: center;
      padding: changeRem(.16)+px changeRem(.24)+px changeRem(.16)+px changeRem(.6)+px;
    }
    .money_time {
      margin-left: auto;
      font-size: 24px;
      color: #333;
      text-align: right;
      line-height: 40px;
      span {
        color: #EA345C;
      }
      a {
        display: inline-block;
        width: 120px;
        height: 26px;
        background: rgba(235, 80, 50, 1);
        border-radius: 4px;
        line-height: 26px;
        text-align: center;
        font-size: 24px;
        color: #fff;
      }
    }
    .money_time1 {
      line-height: 60px;
    }
    .money_right:after {
      position: absolute;
      content: "";
      width: 0;
      height: 0;
      left: changeRem(-.2)+px;
      top: changeRem(.25)+px;
      border-right: changeRem(.2)+px solid #EA345C;
      border-top: changeRem(.2)+px solid #FFF;
      border-bottom: changeRem(.2)+px solid #FFF;
    }
  }
  .date_ {
    background: #fff;
    border: 2px solid #EA345C;
    width: 300px;
    line-height: 70px;
    color: #EA345C;
    font-size: changeRem(.52)+px;
    margin-top: changeRem(.6)+px;
    text-align: center;
    float: left;
  }
  .date_:nth-child(odd) {
    float: right;
  }
  .date_over {
    border-color: #ccc;
    color: #999;
  }
  .date_now {
    background-color: #ccc;
    border-color: #ccc;
    color: #fff;
  }
}

.user_share {
  padding: 0;
  padding-right: changeRem(1)+px;
  padding-top: changeRem(0.8)+px;
  .scoure_name {
    padding-left: changeRem(0.7)+px;
  }
}

// 按钮
.into_btn_box {
  background: #fff;
  width: 100%;
  max-width: 750px;
  line-height: changeRem(1.96)+px;
  height: auto;
  position: fixed;
  left: 50%;
  margin-left: -375px;
  bottom: 0;
  text-align: center;
  z-index: 2;
  font-size: changeRem(.68)+px;
  .into_project {
    display: block;
    width: 100%;
    line-height: changeRem(1.96)+px;
    text-align: center;
    background: #EA345C;
    text-align: center;
    color: #fff;
  }
  .into_btn {
    display: flex;
    .into_btn_spe {
      display: flex;
      width: 100%;
    }
  }
  .free_learn {
    color: #EA345C;
    display: block;
    width: 214px;
    text-align: center;
  }
  .sign_immediately {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #EA345C;
    color: #fff;
  }
  .sign_immediately.only {
    position: relative;
    line-height: 18px;
    align-items: normal;
    padding-top: 25px;
    b {
      position: absolute;
      bottom: 15px;
      left: 0;
      width: 100%;
      text-align: center;
      font-weight: normal;
      font-size: 24px;
    }
  }
  .sign_immediately.only span {
    font-size: 24px;
  }
  .sign_immediatelys {
    background-color: #ccc;
  }
}
.spell {
  font-size: 28px;
  line-height: 34px;
  padding-top: 20px;
  text-align: center;
  padding-bottom: 10px;
  span {
    font-size: 20px;
    color: #999
  }
}

// 修改之
.scoure_name {
  font-size: 30px;
  color: #333333;
}


/* 红包 */

.prize-pop {
  background: rgba(0, 0, 0, 0);
  overflow-y: visible;
  overflow-x: visible;
}

.prize {
  transform: rotateY(0deg) translateY(-200%);
  animation: movelateY .5s forwards;
  color: #EECC8F;
  .bg {
    width: 8rem;
    position: relative;
    z-index: 1;
  }
  .close-btn {
    width: 28px;
    height: 28px;
    position: absolute;
    right: 32px;
    top: 32px;
    overflow-y: hidden;
    z-index: 2;
    background: url(../../../assets/Prize_close.png) top center;
    background-size: cover;
    p {
      width: 100%;
      border-bottom: 3px solid #AC0C11;
      position: absolute;
      left: 0;
      top: 0;
    }
    >p:nth-child(1) {
      transform: rotateZ(45deg);
      top: 10px;
    }
    >p:nth-child(2) {
      transform: rotateZ(-45deg);
      top: 10px;
    }
  }
  img {
    // position: absolute;
    left: 0;
    top: 0;
    width: 8rem;
    max-width: 100%;
  }
  .prize-btn {
    width: 160px;
    position: absolute;
    top: 455px;
    left: 50%;
    margin-left: -70px;
  }
  .row-public {
    width: 100%;
    text-align: center;
    position: absolute;
    span.num-type {
      font-size: 34px;
    }
  }
  .row-spe {
    top: 660px;
  }
  .text-tip {
    top: 210px;
    font-size: 34px;
    font-weight: bold;
  }
  .h1-head {
    top: 136px;
    font-size: 36px;
    font-weight: bold;
  }
  .greet {
    top: 189px;
    font-size: 36px;
    font-weight: bold;
  }
  .num {
    top: 289px;
    font-size: 34px;
    .h2-row {
      font-weight: bold;
      position: relative;
      font-size: 40px;
    }
    .size-sm {
      font-weight: normal;
      font-size: 24px;
      margin-top: 10px;
      position: relative;
    }
  }
  .reward_logo {
    width: 62px;
    position: absolute;
    left: 50%;
    margin-left: -31px;
  }
  .logo_top {
    top: 95px;
  }
  .logo_bottom {
    top: 579px;
  }
  .tip-footer {
    bottom: 44px;
    font-size: 34px;
    font-weight: bold;
  }
}

.prize.show {
  animation: rotate 1s forwards;
}

@keyframes movelateY {
  0% {
    transform: translateY(-200%);
  }
  100% {
    transform: translateY(0%);
  }
}

@keyframes rotate {
  0% {
    transform: rotateY(0deg);
  }
  100% {
    transform: rotateY(360deg);
  }
}


/*弹窗带二维码的*/

.pop_assistant {
  text-align: center;
  background-color: transparent;
  .pop_assistant_box {
    width: 600px;
    border-radius: 8px;
    background-color: #fff;
    padding: 44px 85px 34px;
    img {
      width: 434px;
      height: 434px;
    }
    h3 {
      // margin-top: 44px;
      font-size: 34px;
      color: #333333;
      line-height: 50px;
      span.on {
        color: #EA345C;
      }
    }
    h4 {
      margin-top: 16px;
      font-size: 24px;
      color: #666;
      line-height: 24px;
    }
  }
}
</style>
<style>
.money_box .radio_group {
  margin-bottom: 30px;
  width: 300px;
  line-height: 70px;
  /*height: 70px;*/
  text-align: center;
  color: #EA345C;
  font-size: 26px;
  border: 2px solid rgba(235, 80, 50, 1);
  float: left;
  position: relative;
}

.mev {
  margin-top: 50px
}

.money_box .radio_group:nth-child(even) {
  float: right;
}

.money_box .radio_group_over {
  color: #999999;
  border-color: #ccc
}

.money_box .radio_group:last-child {
  margin-bottom: 0;
}


/* .money_box .radio_group .van-radio {
  width: 100%;*/


/*position: relative;
} */

.money_box .radio_group .van-radio .van-radio__icon {
  position: absolute;
  right: 0;
  bottom: 0;
  height: 36px;
  line-height: 36px;
}

.money_box .radio_group .van-radio .van-radio__icon .van-icon {
  border: none;
  background: none;
}

.money_box .radio_group .van-radio .van-radio__icon .van-icon:before {
  content: '';
}

.radio_group .van-radio .van-radio__icon.van-radio__icon--checked .van-icon.van-icon-success {
  width: 43px;
  height: 36px;
  background-image: url(../../../assets/radio_dw.png);
  background-size: cover;
  border-radius: 0;
  transition: .03s;
}

.money_box .radio_group .van-radio__label {
  line-height: 70px;
  text-align: center;
  color: #EA345C;
  margin-left: 0;
  font-size: 26px;
}

.money_box .radio_group_over .van-radio__label {
  color: #999
}

.order_group {
  color: #333;
  font-size: 26px;
  margin: 0 30px;
  line-height: 80px;
  text-align: left;
  position: relative;
}

.order_group:last-child {
  margin-top: 20px;
}

.order_group .van-radio .van-radio__icon {
  position: absolute;
  right: 0;
  top: 20px;
}

.order_group .van-radio__label {
  margin-left: 0;
}

.order_group .van-radio__label span {
  margin-left: 360px;
  color: #EA345C;
}

.van-radio__icon .van-icon {
  border: 2px solid #ccc;
}

.order_group .van-radio__icon--checked .van-icon {
  border-color: #EA345C;
  background-color: #EA345C;
}

.banq {
  font-size: 26px;
  color: #666;
  width: 100%;
  padding: 20px;
  text-align: justify;
}
</style>
